import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from '@mui/material';
import { useStoreActions } from 'src/stores';
import { Formik, Form, Field } from 'formik';
import { FormInputField } from 'src/components/FormInputField/FormInputField';
import { useAddTransaction } from 'src/api/hooks/useFinance';

import { addTransactionSchema } from './validationSchema';
import { AddTransacModalProps, AddTransactionsData } from './CompanyAccount.types';
import { PopUpEnum } from 'src/stores/NotificationStore';

export const TransactionModal: React.FC<AddTransacModalProps> = ({
  isOpen,
  cancelButtonAction,
  accountId,
}) => {
  const { t } = useTranslation();
  const setPopUpData = useStoreActions(action => action.popUp.setPopUp);

  const inviteInitialState = {
    amount: '',
    description: '',
    metaData: '',
  };

  const [addTransaction] = useAddTransaction({
    onComplete: () => {
      cancelButtonAction();
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.success,
        message: t('alerts.transaction.success'),
      });
    },
    onError: () => {
      cancelButtonAction();
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('alerts.transaction.error'),
      });
    },
  });

  const handleConfirmClicked = (data: AddTransactionsData) => {
    addTransaction({
      variables: {
        ...data,
        amount: data.amount.replace(/\s/g, '').replace(/\./g, ''),
        accountId,
      },
    });
  };

  return (
    <Dialog open={isOpen} onClose={cancelButtonAction} fullWidth maxWidth="md">
      <div>
        <DialogTitle>
          <Trans>companyAccount.modal.title</Trans>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>companyAccount.modal.subTitle</Trans>
          </DialogContentText>
          <Grid>
            <Formik
              enableReinitialize
              initialValues={inviteInitialState}
              validationSchema={addTransactionSchema}
              onSubmit={data => handleConfirmClicked(data)}>
              {() => (
                <Form>
                  <Field
                    label={t('companyAccount.modal.amount')}
                    name="amount"
                    component={FormInputField}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                  <Field
                    label={t('companyAccount.modal.description')}
                    name="description"
                    component={FormInputField}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                  <Field
                    label={t('companyAccount.modal.metaData')}
                    name="metaData"
                    component={FormInputField}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                  <DialogActions>
                    <Button onClick={cancelButtonAction} color="primary" autoFocus>
                      <Trans>generic.cancel</Trans>
                    </Button>
                    <Button color="primary" variant="contained" autoFocus type="submit">
                      <Trans>generic.confirm</Trans>
                    </Button>
                  </DialogActions>
                </Form>
              )}
            </Formik>
          </Grid>
        </DialogContent>
      </div>
    </Dialog>
  );
};
